<section class="col-12">
  <div class="card mb-4 border-dark">
    <div class="card-header text-white bg-dark">
      {{ 'NEW_REQUEST.ENABLEMENT' | translate }}
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-12">
          @if (!hideLackEnablement) {
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                name="enablementType"
                id="enablementTypeLack"
                [(ngModel)]="enablement.type"
                [value]="enablementTypeEnum.Lack"
                (ngModelChange)="emitEnablementChange()"
              />
              <label class="form-check-label" for="enablementTypeLack">
                {{ 'ENABLEMENT_FORM.LACK' | translate }}
              </label>
            </div>
          }
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="enablementType"
              id="enablementTypeStatutory"
              [(ngModel)]="enablement.type"
              [value]="enablementTypeEnum.Statutory"
              (ngModelChange)="emitEnablementChange()"
            />
            <label class="form-check-label" for="enablementTypeStatutory">
              {{ 'ENABLEMENT_FORM.STATUTORY' | translate }}
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="enablementType"
              id="enablementTypeWritten"
              [(ngModel)]="enablement.type"
              [value]="enablementTypeEnum.Written"
              (ngModelChange)="emitEnablementChange()"
            />
            <label class="form-check-label" for="enablementTypeWritten">
              {{ 'ENABLEMENT_FORM.WRITTEN' | translate }}
            </label>
          </div>
        </div>

        @if (isEnablementTypeChosen(enablementTypeEnum.Lack)) {
          @if (submitted && !allowedNoEnablement) {
            <div class="col-12">
              <div class="alert alert-danger my-2">
                {{ 'ENABLEMENT_FORM.CHOOSE_ENABLEMENT_TYPE' | translate }}
              </div>
            </div>
          }
        }
      </div>

      @if (isEnablementTypeChosen(enablementTypeEnum.Statutory)) {
        <div class="row mt-2">
          <div class="col-12">
            <label class="mb-0" for="enablement-legal-basis">
              {{ 'ENABLEMENT_FORM.LEGAL_BASIS' | translate }}
            </label>
          </div>
          <div class="col-12">
            <input
              [(ngModel)]="enablement.legalBasis"
              (ngModelChange)="emitEnablementChange()"
              id="enablement-legal-basis"
              class="form-control form-control-sm required"
              aria-required="true"
              type="text"
              aria-label="Number"
            />
            @if (submitted && !enablement.legalBasis) {
              <div class="alert alert-danger my-2">
                {{ 'FIELD_REQUIRED' | translate }}
              </div>
            }
          </div>
        </div>
      }

      <div class="row mt-2">
        <div class="col-12">
          <label>{{ 'ENABLEMENT_FORM.CHOOSE_DOCUMENT' | translate }}:</label>
          <app-attachment-input
            [isRequired]="isEnablementTypeChosen(enablementTypeEnum.Written)"
            [wasValidated]="submitted"
            (fileChanged)="handleEnablementDocumentInput($event)"
            [stringifiedFile]="stringifiedEnablementDocumentFile"
          ></app-attachment-input>
          @if (
            submitted &&
            isEnablementTypeChosen(enablementTypeEnum.Written) &&
            !base64Document
          ) {
            <div class="alert alert-danger mt-2 mb-0">
              {{
                'NEW_DESIGNER_REQUEST_FORM.PROVIDE_REQUIRED_ATTACHMENTS'
                  | translate
              }}
            </div>
          }
          @if (documentConvertLoading) {
            <div class="d-flex justify-content-center my-3">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">{{ 'LOADING' | translate }}</span>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</section>

@if (!isEnablementTypeChosen(enablementTypeEnum.Lack)) {
  <section class="col-12">
    <div class="card mb-4 border-dark">
      <div class="card-header text-white bg-dark">
        {{ 'NEW_REQUEST.PRINCIPAL' | translate }}
      </div>

      <div class="card-body row">
        <gk-law-person-search
          [multiplePersonSelect]="false"
          [addingPersonsDirectlyToDb]="addingPersonsDirectlyToDb"
          [isRequired]="isEnablementTypeChosen(enablementTypeEnum.Statutory)"
          [legalPersonOnly]="legalPersonOnly"
          [forcePeselRequired]="true"
          [staticSelectedTableValue]="staticSelectedTableValue"
          [primitivePostalCode]="primitivePostalCode"
          [searchLegalPersonCustomUrl]="searchLegalPersonCustomUrl"
          [legalPersonSearchFieldsToHide]="[
            legalPersonControlName.TypeId,
            legalPersonControlName.Name,
            legalPersonControlName.KrsNumber,
          ]"
          [(selectedLawPersons)]="chosenLawPersons"
          (selectedLawPersonsChange)="emitEnablementChange()"
        ></gk-law-person-search>
      </div>

      @if (submitted && !isChosenPersonValid()) {
        <div class="card-footer">
          <div class="alert alert-danger my-2">
            {{ 'ENABLEMENT_FORM.CHOOSE_PLENIPOTENTIARY' | translate }}
          </div>
        </div>
      }
    </div>
  </section>
}
